import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";

// Fil d'Ariane. items: [{ label, to? }] — le dernier élément est la position courante.
export default function Breadcrumb({ items = [] }) {
  const valid = items.filter(Boolean);
  if (valid.length === 0) return null;
  return (
    <nav aria-label="Fil d'Ariane" className="flex items-center gap-1.5 text-xs text-marine/80 mb-3 flex-wrap" data-testid="breadcrumb">
      {valid.map((it, i) => {
        const last = i === valid.length - 1;
        return (
          <span key={i} className="flex items-center gap-1.5">
            {it.to && !last
              ? <Link to={it.to} className="hover:text-marine transition-colors">{it.label}</Link>
              : <span className={last ? "text-marine font-medium" : ""}>{it.label}</span>}
            {!last && <Icons.ChevronRight size={16} className="text-muet" />}
          </span>
        );
      })}
    </nav>
  );
}
